"use client";

import { Variants } from "motion/react";
import * as m from "motion/react-m";
import { Bar } from "./components/Bar";

type BarChartProps = {
  label: string;
  data: {
    label: string;
    value: number;
  }[];
};

export const BarChart = ({ label, data }: BarChartProps) => {
  const values = data.map((d) => d.value);
  const max = Math.max(...values);

  const getBarStyle = (value: number) => {
    if (value === max) return "bg-report-purple-400";
    return "bg-report-grey-300";
  };

  return (
    <div className="border-report-grey-200 min-w-0 flex-1 border-t-2 md:border-none">
      <div className="max-w-1/2 bg-report-grey-200 text-report-black relative mb-6 py-2 pl-1 lg:mb-10">
        <h4 className="text-report-body-large-mobile xl:text-report-body-large font-bold">
          {label}
        </h4>
      </div>
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={{ margin: "0px 0px -20% 0px" }}
        className="flex aspect-[386/280] gap-0.5 md:aspect-[491/450]"
      >
        {data.map((item, index) => (
          <Bar
            key={index}
            label={item.label}
            value={item.value}
            barClassName={getBarStyle(item.value)}
          />
        ))}
      </m.div>
    </div>
  );
};
